import React from 'react';
import PropTypes from 'prop-types';
import { AppContext } from '@prisjakt/ui-app-context';
import ProductRow from '@prisjakt/ui-product-row';
import ProductImage from '@prisjakt/ui-product-image';
import OpenInNewIcon from 'mdi-react/OpenInNewIcon';
import T from '@prisjakt/ui-translate';
import { connect } from 'react-redux';
import PanelHeader from '@prisjakt/ui-panel-header';
import Dropdown from '@prisjakt/ui-dropdown';
import queryString from 'querystring';
import { withRouter } from 'react-router';
import PriceLabel from '@prisjakt/ui-price-label';

import PageContent from '../../components/page-content';
import ProductListing from '../category/components/product-listing';
import Viewport, { ViewportContext } from '../../components/viewport';

import actions from './actions/search';
import { productPriceClick } from '../product/actions/product';

import Facets from './components/facets';
import ExtraResources from './components/extra-resources';

import * as S from './styles';

class Search extends React.PureComponent {
  changeSort(sort) {
    const qs = queryString.decode(this.props.location.search.substr(1));

    qs.sort = sort;

    this.props.history.replace(
      `${this.props.location.pathname}?${queryString.encode(qs)}`
    );
  }

  render() {
    const {
      query,
      resources: { products, brands, stores },
    } = this.props.data.search;
    const { t } = this.context;

    this.sortOptions = this.sortOptions || [
      {
        name: t('common', 'sort.relevance'),
        value: `score:desc`,
      },
      {
        name: t('common', `sort.price:asc`),
        value: `lowest_price:asc`,
      },
      {
        name: t('common', `sort.price:desc`),
        value: `lowest_price:desc`,
      },
      {
        name: t('common', `sort.name`),
        value: `product_name:asc`,
      },
      {
        name: t('common', `sort.user_reviews`),
        value: `user_rating:desc`,
      },
    ];

    return (
      <PageContent withAds>
        <S.Header data-test="HeaderText">
          <T domain="search" query={query}>
            search-results.title
          </T>
        </S.Header>
        <S.Wrapper>
          <ViewportContext.Consumer>
            {({ isMobile }) => (
              <>
                <S.Sidebar>
                  <Facets
                    onToggleFacet={this.toggleFacet}
                    facets={products.facets}
                    inactiveTypes={isMobile ? ['SearchFacetInterval'] : []}
                    maxListItems={isMobile ? 3 : Infinity}
                    showSubtitle={!isMobile}
                  />
                  <Viewport tablet desktop>
                    {brands && brands.nodes.length > 0 && (
                      <ExtraResources
                        title={t('search', 'brands.title')}
                        subtitle={t('search', 'results.n-results', {
                          n: brands.nodes.length,
                        })}
                        more={t('search', 'brands.more')}
                        resource={brands}
                      />
                    )}
                    {stores && stores.nodes.length > 0 && (
                      <ExtraResources
                        title={t('search', 'stores.title')}
                        subtitle={t('search', 'results.n-results', {
                          n: stores.nodes.length,
                        })}
                        more={t('search', 'stores.more')}
                        resource={stores}
                      />
                    )}
                  </Viewport>
                </S.Sidebar>
                <ProductListing
                  header={
                    <S.ResultsHeader>
                      <PanelHeader
                        title={t('search', 'results.title')}
                        subtitle={t('search', 'results.n-results', {
                          n: products.pageInfo.total,
                        })}
                      >
                        <Dropdown
                          title={isMobile ? '' : t('common', 'sort.title')}
                          options={this.sortOptions}
                          selected={
                            (
                              this.sortOptions.find(
                                option =>
                                  option.value ===
                                  [
                                    products.pageInfo.sort.name,
                                    products.pageInfo.sort.direction,
                                  ].join(':')
                              ) || this.sortOptions[0]
                            ).name
                          }
                          onSelect={option => {
                            this.changeSort(option.value);
                          }}
                        />
                      </PanelHeader>
                    </S.ResultsHeader>
                  }
                  products={{
                    pageInfo: products.pageInfo,
                    nodes: products.nodes.filter(x => x.type === 'Product'),
                  }}
                  selectedProperties={[]}
                  mode="row"
                  pageInfo={products.pageInfo}
                  withFilter={false}
                  showPagination
                  showRatings
                  showCategory={false}
                  adverts={{
                    desktopInline: null,
                  }}
                >
                  <div>
                    {products.nodes
                      .filter(x => x.type === 'Raw')
                      .map(item => (
                        <ProductRow
                          key={item.id}
                          onClick={() => {
                            this.props.productPriceClick(
                              null,
                              item.price,
                              item.featured,
                              'raw'
                            );
                          }}
                          name={item.name}
                          price={<PriceLabel value={item.price || null} />}
                          link={item.externalUri}
                          image={<ProductImage name={item.name} />}
                          subtitle={
                            <span>
                              {item.store.name}
                              {' - '}
                              <span>
                                <T domain="search">raw-search.go-to-shop</T>
                                <OpenInNewIcon size={14} />
                              </span>
                            </span>
                          }
                          linkAttributes={{
                            target: '_blank',
                            rel: 'nofollow',
                          }}
                          showDivider
                        />
                      ))}
                  </div>
                </ProductListing>
                <Viewport mobile>
                  <S.Sidebar>
                    {brands && brands.nodes.length > 0 && (
                      <ExtraResources
                        title={t('search', 'brands.title')}
                        subtitle={t('search', 'results.n-results', {
                          n: brands.nodes.length,
                        })}
                        more={t('search', 'brands.more')}
                        resource={brands}
                      />
                    )}
                    {stores && stores.nodes.length > 0 && (
                      <ExtraResources
                        title={t('search', 'stores.title')}
                        subtitle={t('search', 'results.n-results', {
                          n: stores.nodes.length,
                        })}
                        more={t('search', 'stores.more')}
                        resource={stores}
                      />
                    )}
                  </S.Sidebar>
                </Viewport>
              </>
            )}
          </ViewportContext.Consumer>
        </S.Wrapper>
      </PageContent>
    );
  }
}

const { func, object } = PropTypes;

Search.propTypes = {
  data: object,
  location: object.isRequired,
  history: object.isRequired,
  productPriceClick: func.isRequired,
};

Search.defaultProps = {
  data: null,
};

Search.contextType = AppContext;

export default withRouter(
  connect(undefined, { ...actions, productPriceClick })(Search)
);
